<template>
  <div class="withholdingList">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @searchCompanyName="searchCompanyName"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnListDefault"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @dblclickEvent="dblclickEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width || 120"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :type="item.type"
          :params="item.params"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <choiceType ref="choiceType" />
    <!--批量确认 -->
    <BatchConfirmDialog ref="batchConfirmDialog" />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/financeCenter/transfer';
  import DataBaseAPI from '@/api/dataBase';
  import { filterEmpty } from '@/common/js/util';
  import tableMixins from '@/common/mixins/table.js';
  // import qs from 'qs';
  // import siruiUpload from '@/components/SiruiUpload';
  // import loading from '@/common/js/load.js'; //loading
  // import InputNumber from '@/components/form-item/input-number';
  import choiceType from './components/choiceType';
  import BatchConfirmDialog from '@/components/Dialog/batchConfirmDialog';
  import XEUtils from 'xe-utils';
  export default {
    name: 'transferList',
    mixins: [tableMixins],
    components: {
      // siruiUpload,
      // InputNumber,
      choiceType,
      BatchConfirmDialog,
    },
    data() {
      return {
        footerTotalCols: { amount: ['transferAmount'] }, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点
        query: {
          transferNo: undefined, //转款单号
          originPartnerCode: undefined, //原合作伙伴/抹账方
          transferPartnerCode: undefined, //转款合作伙伴/被抹账方
          originDepartmentCode: undefined, //原业务部门名称
          transferBusinessDepartmentCode: undefined, //转款部门
          accountingStatus: undefined, //入账状态
          transferDate: undefined, //转款日期
          transferDateStart: undefined,
          transferDateEnd: undefined,
          transferAmount: undefined, //转款金额
          transferType: 'TT01', //业务类型 ：默认值付款转款
          transferStatus: undefined, //单据状态
          judgeFlag: null,
          voucherNo: null,
        },
        companyList: [], //公司列表
        departmentList: [], //部门列表
        //表格显示字段
        /* columnListDefault:[
        { type: "checkbox", visible: true, width: "50", fixed: "left" },
        { field: "transferNo", title: "转款单号", visible: true,width:150, },//转款单号
        { field: "transferType", title: "业务类型", visible: true,width:120, dictType:'transferType' },//业务类型
        { field: "originPartnerName", title: "原合作伙伴/抹账方", visible: true,width:150, },//原合作伙伴
        { field: "transferPartnerName", title: "转款合作伙伴/被抹账方", visible: true,width:150, },//原合作伙伴
        { field: "transferAmount", title: "转款金额", visible: true,width:120,format:"formatAmountRound", },//转款金额
        { field: "transferDate", title: "转款日期", visible: true,width:120, },//转款日期
        { field: "transferBusinessDepartmentName", title: "转款部门", visible: true,width:150, },//转款部门
        { field: "accountingStatus", title: "入账状态", visible: true,width:120,dictType:'post_status' },//入账状态
        { field: "transferStatus", title: "单据状态", visible: true,width:120,dictType:'transferStatus' },//单据状态
        { field: "accountedDate", title: "过账日期", visible: true,width:120 },//过账日期
        { field: "businessCompanyName", title: "公司名称", visible: true,width:150 },//公司名称
        { field: "originBusinessDepartmentName", title: "原业务部门名称", visible: true,width:150 },//原业务部门名称
      ], */
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        dictList: (state) => state.dict.dictList,
        tokenInfo() {
          return {
            access_token: this.userInfo.access_token,
            companyCode: this.userInfo.companyCode,
            companyName: this.userInfo.companyName,
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            tenantCode: this.userInfo.tenantCode,
          };
        },
      }),
      //搜索字段
      searchColumns() {
        return [
          //业务类型
          {
            prop: 'transferType',
            name: '业务类型',
            type: 'dict',
            dictType: 'transferType',
            clearable: true,
            required: true,
          },
          {
            //公司代码
            prop: 'businessCompanyCode',
            name: '公司名称',
            type: 'select',
            placeholder: '请选择公司名称',
            options: this.companyList,
            relatedColumn: 'none',
            changeMethod: 'searchCompanyName',
          },
          {
            //部门
            prop: 'transferBusinessDepartmentCode',
            name: '转款部门',
            placeholder: '请选择转款部门',
            type: 'select',
            relatedColumn: 'none',
            options: this.departmentList,
          },
          //转款单号
          {
            prop: 'transferNo',
            name: '转款单号',
            type: 'input',
            placeholder: '请输入转款单号',
          },
          //原合作伙伴/抹账方
          {
            prop: 'originPartnerCode',
            type: 'searchTableSpec',
            name: '原合作伙伴/抹账方',
            placeholder: '请选择原合作伙伴/抹账方',
            searchType: 'partner',
            isMultiple: true,
          },
          //转款合作伙伴/被抹账方
          {
            prop: 'transferPartnerCode',
            type: 'searchTableSpec',
            name: '转款合作伙伴/被抹账方',
            placeholder: '请选择转款合作伙伴/被抹账方',
            searchType: 'partner',
            isMultiple: true,
          },
          //入账状态
          {
            prop: 'accountingStatus',
            name: '入账状态',
            type: 'dict',
            dictType: 'post_status',
          },
          {
            //单据状态
            prop: 'transferStatus',
            type: 'dict',
            dictType: 'transferStatus',
            name: '单据状态',
            clearable: true,
          },
          // 转款金额
          {
            type: 'selectInput',
            prop: ['judgeFlag', 'transferAmount'],
            name: '转款金额',
            options: [
              { value: 1, label: '大于' },
              { value: 2, label: '小于' },
              { value: 3, label: '不等于' },
              { value: 4, label: '等于' },
              { value: 5, label: '大于等于' },
              { value: 6, label: '小于等于' },
            ],
          },
          // 转款日期
          {
            prop: 'transferDateStart',
            name: '转款日期从',
            type: 'startDaterangePicker',
          },
          {
            prop: 'transferDateEnd',
            name: '转款日期至',
            type: 'endDaterangePicker',
          },
          {
            prop: 'voucherNo',
            name: '凭证号',
            type: 'input',
            placeholder: this.$t('请输入凭证号'),
          },
        ];
      },
      //表格显示字段
      columnListDefault() {
        return [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          { field: 'transferNo', title: '转款单号', visible: true, width: 150 }, //转款单号
          {
            field: 'transferType',
            title: '业务类型',
            visible: true,
            width: 120,
            dictType: 'transferType',
          }, //业务类型
          { field: 'originPartnerName', title: '原合作伙伴/抹账方', visible: true, width: 150 }, //原合作伙伴
          {
            field: 'transferPartnerName',
            title: '转款合作伙伴/被抹账方',
            visible: true,
            width: 150,
          }, //原合作伙伴
          {
            field: 'transferAmount',
            title: '转款金额',
            visible: true,
            width: 120,
            format: 'formatAmountRound',
          }, //转款金额
          { field: 'transferDate', title: '转款日期', visible: true, width: 120 }, //转款日期
          { field: 'transferBusinessDepartmentName', title: '转款部门', visible: true, width: 150 }, //转款部门
          {
            field: 'accountingStatus',
            title: '入账状态',
            visible: true,
            width: 120,
            dictType: 'post_status',
          }, //入账状态
          {
            field: 'transferStatus',
            title: '单据状态',
            visible: true,
            width: 120,
            dictType: 'transferStatus',
          }, //单据状态
          {
            field: 'voucherNo',
            title: '凭证号',
            visible: true,
          },
          { field: 'accountedDate', title: '过账日期', visible: true, width: 120 }, //过账日期
          { field: 'businessCompanyName', title: '公司名称', visible: true, width: 150 }, //公司名称
          {
            field: 'originBusinessDepartmentName',
            title: this.transferTypeFlag == 'TT01' ? '原付款部门名称' : '原收款部门名称',
            visible: true,
            width: 150,
          }, //原收款/原付款部门名称-根据类型判断
          {
            field: 'originPartnerName',
            title:
              this.transferTypeFlag == 'TT01'
                ? '原供应商名称'
                : this.transferTypeFlag == 'TT02'
                ? '原客户名称'
                : '交易方名称',
            visible: true,
            width: 150,
          }, //原客户/原供应商名称
        ];
      },
    },
    /**页面必要代码Start */
    mounted() {
      if (Object.keys(this.$route.query).length > 0) {
        let query = this.$route.query;
        this.query.transferType = query.transferType;
      }
      this.getButtonList();
      this.getCompany();
      this.getData();
    },
    methods: {
      getDictValue({ cellValue, column }) {
        return this.$baseRequest.getDictValueByType(column.params.name, cellValue);
      },
      //获取公司信息
      async getCompany() {
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          let personCompanyInfo = selectStatus.data.data.personCompanyInfo || [];
          if (personCompanyInfo[0]) {
            this.companyList = personCompanyInfo.map((it) => {
              return { value: it.personCompanyCode, label: it.personCompanyName };
            });
          }
        }
      },
      //获取数据
      getData() {
        let query = this.setSearchParams();
        if (!this.query.transferType) {
          this.loading.endLoading();
          return this.$message({
            showClose: true,
            message: '业务类型必填',
            type: 'error',
          });
        }
        this.loading.startLoading();
        this.$axios.post(API.TRANSFER_LIST, filterEmpty(query)).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.transferTypeFlag = this.query.transferType;
            this.tableData = res.data.data.records || [];
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 查询参数整理
      setSearchParams() {
        // 分页数据
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const query = this.query;
        const result = Object.assign({}, query, {
          pageNum,
          pageSize,
          originPartnerCode:
            query.originPartnerCode && query.originPartnerCode[0]
              ? query.originPartnerCode[0].partnerCode
              : '',
          transferPartnerCode:
            query.transferPartnerCode && query.transferPartnerCode[0]
              ? query.transferPartnerCode[0].partnerCode
              : '',
        });
        return filterEmpty(result);
      },
      // 选择公司
      searchCompanyName(val) {
        this.departmentList = [];
        this.query.transferPartnerCode = '';
        this.getdepartmentList(val.val);
      },
      // 根据公司查询部门
      async getdepartmentList(companyCode) {
        // TODO 公司代码字段未定
        this.departmentList = [];
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: companyCode,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          let personDepartmentInfo = selectStatus.data.data.personDepartmentInfo || [];
          if (personDepartmentInfo[0]) {
            this.departmentList = personDepartmentInfo.map((it) => {
              return { value: it.personDepartmentCode, label: it.personDepartmentName };
            });
          }
        }
      },
      //点击按钮触发的方法
      chooseClick(type) {
        console.log(type);
        if (type == 'add') {
          this.add();
        } else if (type == 'edit') {
          if (this.multipleSelection.length !== 1) {
            this.$message({
              showClose: true,
              message: '请选择一条数据修改',
              type: 'error',
            });
          } else {
            const item = this.multipleSelection[0];
            if (['Saved', 'Rejected'].indexOf(item.docStatus) != -1) {
              let path = {
                path: '/withholding/withholdingEdit',
                name: 'withholdingEdit',
                meta: {
                  keepAlive: true,
                  title: '预提单编辑',
                },
                query: { id: item.id },
              };
              this.$store.dispatch('tagsView/addTabView', path).then(() => {
                this.$nextTick(() => {
                  this.$router.push(path);
                });
              });
            } else {
              this.$message({
                showClose: true,
                message: '当前数据无法修改',
                type: 'error',
              });
            }
          }
        } else if (type == 'copy') {
          if (this.multipleSelection.length !== 1) {
            this.$message({
              showClose: true,
              message: '请选择一条数据复制',
              type: 'error',
            });
          } else {
            const item = this.multipleSelection[0];
            let path = {
              path: '/withholding/withholdingAdd',
              name: 'withholdingAdd',
              meta: {
                keepAlive: true,
                title: '预提单新建',
              },
              query: { id: item.id, copy: true },
            };
            this.$store.dispatch('tagsView/addTabView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push(path);
              });
            });
          }
        } else if (type == 'delete') {
          this.delete();
        } else if (type == 'export') {
          this.export();
        } else if (type == 'syncVoucher') {
          this.batchSyncVoucher(API.TRANSFER_BATCHSYNCVOUCHER, {
            ids: this.multipleSelection.map((it) => it.id),
          });
        } else if (type == 'signSyncVoucher') {
          this.batchSyncVoucher(API.TRANSFER_SIGN_BATCHSYNCVOUCHER, {
            ids: this.multipleSelection.map((it) => it.id),
          });
          // ============ liuhongxia  批量生成凭证 ============
        } else if (type === 'doBatchConfirm') {
          this.doBatchConfirm(
            'AE_AP_TRANSFER',
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        } else {
          this.$message({
            showClose: true,
            message: this.$t('error.clickError'),
            type: 'error',
          });
        }
      },
      //新增
      add() {
        this.$refs.choiceType.openDialog(true);
      },
      // 删除
      delete() {
        if (this.multipleSelection.length == 0) {
          this.$message({
            showClose: true,
            message: '请选择需要删除的数据',
            type: 'error',
          });
          return false;
        } else {
          let canDelitems = [];
          for (let i = 0; i < this.multipleSelection.length; i++) {
            let temp = this.multipleSelection[i];
            if (temp.docStatus != 'Saved' && temp.docStatus != 'Rejected') {
              this.$message({
                showClose: true,
                message: '只能选择保存或者退回状态的记录！',
                type: 'error',
              });
              return false;
            } else {
              canDelitems.push(temp['id']);
            }
          }
          this.$confirmAction()
            .then(() => {
              this.$axios.post(API.TRANSFER_DELETE, canDelitems).then((res) => {
                if (0 == res.data.code) {
                  this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                  this.resetBtnClick();
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        }
      },
      // 跳转详情页
      dblclickEvent(e) {
        let path = {
          path: '/transfer/transferEdit',
          name: 'transferEdit',
          meta: {
            keepAlive: true,
            title: '转款单详情',
          },
          query: { id: e.row.id, transferType: e.row.transferType },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 导出
      export() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'ids=' + item.id + '&';
          // });
          window.location.href = `${this.baseUrl}${API.TRANSFER_EXPORTS}?${str}access_token=${this.userInfo.access_token}`;
        } else {
          let params = this.query;
          delete params.pageNum;
          delete params.pageSize;
          params = XEUtils.serialize(params);
          var reg = new RegExp('%5B%5D', 'g');
          params = params.replace(reg, '');
          window.location.href = `${this.baseUrl}${API.TRANSFER_EXPORTS}?${params}&access_token=${this.userInfo.access_token}`;
        }
      },
    },
  };
</script>
